module.exports = __webpack_public_path__ + "static/img/logo-mini.d2eb085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-mini.png
// module id = Zmp1
// module chunks = 58